import {CrudService} from '../services/';
import {CITIES} from "../../constants";

export const fetchCities = (params = {}, dispatch) => {
    return CrudService._get({
        url: 'cities',
        consts: {
            start: CITIES.FETCH,
            success: CITIES.FETCH_SUCCESS,
            failure: CITIES.FETCH_FAILURE,
        },
        params
    }, dispatch);
};

export const getCity = (id, params = {}) => {
    return CrudService._get({
        url: `cities/${id}`,
        params
    });
};